import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { onSelectableItemClick } from '../actions';
import { getSelectedDeviationIds, getSelectionLimit } from '../selectors';
import { getDeviationsByIds } from '../../redux/deviations/selectors';
const mapStateToProps = (state, ownProps)=>{
    const selectionLimit = getSelectionLimit(state) || ownProps.selectionLimit;
    const selectedDeviationEntityIds = getSelectedDeviationIds(state);
    const selectedDeviations = getDeviationsByIds(state, selectedDeviationEntityIds);
    return {
        selectionLimit,
        selectedDeviationEntityIds,
        selectedDeviationIds: selectedDeviationEntityIds.map(Number),
        selectedDeviations,
        selectedCount: selectedDeviations.length,
        canSelectMore: selectionLimit && selectedDeviations.length < selectionLimit
    };
};
const mapDispatchToProps = {
    onSelectableItemClick
};
export const useDeviationSelection = ()=>_object_spread({}, useMMSelector((state)=>mapStateToProps(state, {})), useMMDispatchActions(mapDispatchToProps));
export default connectMediaStore(mapStateToProps, mapDispatchToProps);
